import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { TerminalsTextarea } from "./TerminalsTextarea";

export const TerminalsTextareaField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    // Determine which table field to update based on the textarea field name
    // textareaTerminalsInput1 -> terminals1, textareaTerminalsInput2 -> terminals2
    const tableFieldName = field.name.replace("textareaTerminalsInput", "terminals");

    return (
        <Form.Item name={field.name} rules={rules}>
            <TerminalsTextarea readOnly={readOnly} tableFieldName={tableFieldName} />
        </Form.Item>
    );
};
